export const autoLinksValidations = {
  telegram: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  github: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  gitlab: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  git: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  bitbucket: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  deviantart: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  discord: (value) => /^[#_.\-a-zA-Z0-9]+$/i.test(value),
  facebook: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  instagram: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  mail: (value) => /^[@_.\-a-zA-Z0-9]+$/i.test(value),
  phone: (value) => /^[+0-9]+$/i.test(value),
  spotify: () => true,
  steam: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  twitch: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  twitter: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  tiktok: (value) => /^[@_.\-a-zA-Z0-9]+$/i.test(value),
  whatsapp: (value) => /^[+0-9]+$/i.test(value),
  youtube: (value) => /^[@_.\-a-zA-Z0-9]+$/i.test(value),
  website: () => true,
  link: () => true,
  linkedin: () => true,
  soundcloud: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
  lastfm: (value) => /^[_.\-a-zA-Z0-9]+$/i.test(value),
};

export const autoLinksPlaceholders = {
  telegram: "telegran_username",
  github: "github_username",
  gitlab: "gitlab_username",
  git: "https://",
  bitbucket: "bitbucket_username",
  deviantart: "deviantart_username",
  discord: "discord_tag#0000",
  facebook: "facebook_username",
  instagram: "instagram_username",
  mail: "mail@example.id",
  phone: "08123456",
  spotify: "https://",
  steam: "steam_username",
  twitch: "twitch_username",
  twitter: "x_username",
  tiktok: "@tiktok_username",
  whatsapp: "+62812345678",
  youtube: "@youtube_handles",
  website: "https://",
  link: "https://",
  linkedin: "https://",
  soundcloud: "soundcloud_username",
  lastfm: "lastfm_username",
};

export const autoLinksPrefix = {
  telegram: "https://t.me/",
  github: "https://github.com/",
  gitlab: "https://gitlab.com/",
  // git: "https://",
  bitbucket: "https://bitbucket.com/",
  deviantart: "https://www.deviantart.com/",
  discord: "copy",
  facebook: "https://fb.me/",
  instagram: "https://instagram.com/",
  mail: "mailto:",
  phone: "tel:",
  // spotify: "https://",
  steam: "https://steamcommunity.com/id/",
  twitch: "https://www.twitch.tv/",
  twitter: "https://twitter.com/",
  tiktok: "https://www.tiktok.com/",
  whatsapp: "https://wa.me/",
  youtube: "https://www.youtube.com/",
  // website: "https://",
  // link: "https://",
  // linkedin: "https://",
  soundcloud: "https://soundcloud.com/",
  lastfm: "https://www.last.fm/user/",
};
